(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["final-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const nodes = document.querySelectorAll('[data-final-cta-content]');
    if (!nodes.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    nodes.forEach((node) => {
      node.classList.add('is-ready');
      observer.observe(node);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-site-nav]');
    if (!root) return;

    const bar = root.querySelector('[data-site-nav-bar]');
    const toggle = root.querySelector('[data-site-nav-toggle]');
    const mobile = root.querySelector('[data-site-nav-mobile]');
    const menuIcon = toggle && toggle.querySelector('.site-nav__icon--menu');
    const closeIcon = toggle && toggle.querySelector('.site-nav__icon--close');

    const setOpen = (open) => {
      root.classList.toggle('is-open', open);
      if (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute(
          'aria-label',
          open ? toggle.dataset.closeLabel : toggle.dataset.openLabel
        );
      }
      if (mobile) mobile.hidden = !open;
      if (menuIcon) menuIcon.hidden = open;
      if (closeIcon) closeIcon.hidden = !open;
    };

    if (toggle) {
      toggle.addEventListener('click', () => {
        setOpen(!root.classList.contains('is-open'));
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });

    if (mobile) {
      mobile.addEventListener('click', (event) => {
        if (event.target.closest('a')) setOpen(false);
      });
    }

    const onScroll = () => {
      if (!bar) return;
      bar.classList.toggle('is-scrolled', window.scrollY > 20);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const COLOR_MAP = {
      blue: {
        stroke: '#3FB8FF',
        fill: 'rgba(63,184,255,0.95)',
        glow: 'rgba(63,184,255,0.7)',
        panelGlow: 'rgba(63,184,255,0.5)',
        soft: 'rgba(63,184,255,0.12)',
      },
      gold: {
        stroke: '#F0D27A',
        fill: 'rgba(240,210,122,0.95)',
        glow: 'rgba(229,194,90,0.7)',
        panelGlow: 'rgba(229,194,90,0.5)',
        soft: 'rgba(229,194,90,0.12)',
      },
      green: {
        stroke: '#5EE6B5',
        fill: 'rgba(94,230,181,0.95)',
        glow: 'rgba(94,230,181,0.7)',
        panelGlow: 'rgba(94,230,181,0.5)',
        soft: 'rgba(94,230,181,0.12)',
      },
    };

    function initHero(root) {
      const organsScript = root.querySelector('[data-hero-organs]');
      if (!organsScript) return;

      let organs = [];
      try {
        organs = JSON.parse(organsScript.textContent);
      } catch (error) {
        return;
      }
      if (!Array.isArray(organs) || !organs.length) return;

      const hotspotsRoot = root.querySelector('[data-body-hotspots]');
      const connector = root.querySelector('[data-body-connector]');
      const video = root.querySelector('[data-body-video]');
      const panel = root.querySelector('[data-organ-panel]');
      const panelTitle = root.querySelector('[data-organ-title]');
      const panelTagline = root.querySelector('[data-organ-tagline]');
      const panelBody = root.querySelector('[data-organ-body]');
      const panelImage = root.querySelector('[data-organ-image]');
      const panelFigure = panelImage && panelImage.closest('.organ-panel__figure');
      const panelGlow = root.querySelector('[data-organ-glow]');
      const panelIndex = root.querySelector('[data-organ-index]');
      const panelCtaWrap = root.querySelector('[data-organ-cta-wrap]');
      const panelCta = root.querySelector('[data-organ-cta]');
      const particlesRoot = root.querySelector('[data-organ-particles]');
      const inspectTemplate = root.dataset.inspectLabel || 'Inspect __NAME__';
      const shopUrl = root.dataset.shopUrl || '/collections/all';

      let activeId = null;
      let hoveredId = null;

      function colorFor(organ) {
        return COLOR_MAP[organ.color] || COLOR_MAP.blue;
      }

      function startVideo() {
        if (!video) return;
        video.muted = true;
        const playback = video.play();
        if (playback) playback.catch(() => {});
      }

      if (video) {
        [0, 250, 1000].forEach((delay) => window.setTimeout(startVideo, delay));
        video.addEventListener('loadeddata', startVideo);
        video.addEventListener('canplay', startVideo);
        window.addEventListener('pageshow', startVideo);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') startVideo();
        });
      }

      function renderHotspots() {
        hotspotsRoot.innerHTML = '';
        organs.forEach((organ, index) => {
          const color = colorFor(organ);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hero-hotspot';
          button.dataset.organId = organ.id;
          button.setAttribute('aria-label', inspectTemplate.replace('__NAME__', organ.name));
          button.setAttribute('aria-pressed', 'false');
          button.style.left = `${organ.x}%`;
          button.style.top = `${organ.y}%`;
          button.style.setProperty('--hotspot-stroke', color.stroke);
          button.style.setProperty('--hotspot-fill', color.fill);
          button.style.setProperty('--hotspot-glow', color.glow);
          button.style.setProperty('--hotspot-delay', `${(index * 0.25) % 2.4}s`);

                  button.innerHTML = `
            <span class="hero-hotspot__ring"></span>
            <span class="hero-hotspot__ripple"></span>
            <span class="hero-hotspot__core"></span>
            <span class="hero-hotspot__dot"></span>
            <span class="hero-hotspot__preview hero-hotspot__preview--${organ.previewSide}">
              <span class="hero-hotspot__preview-inner">
                <span class="hero-hotspot__preview-media">
                  <img src="${organ.image}" alt="${escapeHtml(organ.imageAlt)}" width="352" height="198" loading="lazy" decoding="async">
                </span>
                <span class="hero-hotspot__preview-copy">
                  <span class="hero-hotspot__preview-name">${escapeHtml(organ.name)}</span>
                  <span class="hero-hotspot__preview-tagline">${escapeHtml(organ.tagline)}</span>
                </span>
              </span>
            </span>
          `;

          button.addEventListener('mouseenter', () => {
            if (activeId) return;
            hoveredId = organ.id;
            syncHotspotStates();
          });
          button.addEventListener('mouseleave', () => {
            hoveredId = null;
            syncHotspotStates();
          });
          button.addEventListener('focus', () => {
            if (activeId) return;
            hoveredId = organ.id;
            syncHotspotStates();
          });
          button.addEventListener('blur', () => {
            hoveredId = null;
            syncHotspotStates();
          });
          button.addEventListener('click', () => openOrgan(organ.id));
          hotspotsRoot.appendChild(button);
        });
      }

      function syncHotspotStates() {
        hotspotsRoot.querySelectorAll('.hero-hotspot').forEach((node) => {
          const isActive = node.dataset.organId === activeId;
          const isHovered = !activeId && node.dataset.organId === hoveredId;
          node.classList.toggle('is-active', isActive || isHovered);
          node.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function updateConnector(organ) {
        if (!connector || !organ) {
          if (connector) {
            connector.hidden = true;
            connector.innerHTML = '';
          }
          return;
        }
        const color = colorFor(organ);
        connector.hidden = false;
        connector.innerHTML = `
          <line
            x1="${organ.x}%"
            y1="${organ.y}%"
            x2="100%"
            y2="50%"
            stroke="${color.stroke}"
            stroke-width="1.5"
            stroke-dasharray="4 4"
            opacity="0.6"
          ></line>
          <circle cx="100%" cy="50%" r="4" fill="${color.stroke}"></circle>
        `;
      }

      function renderParticles(color) {
        if (!particlesRoot) return;
        particlesRoot.innerHTML = '';
        for (let i = 0; i < 15; i += 1) {
          const size = 1.5 + Math.random() * 2;
          const dot = document.createElement('span');
          dot.className = 'organ-panel__particle';
          dot.style.width = `${size}px`;
          dot.style.height = `${size}px`;
          dot.style.left = `${Math.random() * 100}%`;
          dot.style.top = `${Math.random() * 100}%`;
          dot.style.setProperty('--particle-color', color.stroke);
          dot.style.setProperty('--duration', `${8 + Math.random() * 10}s`);
          dot.style.setProperty('--delay', `${Math.random() * 6}s`);
          dot.style.setProperty('--drift', `${(Math.random() - 0.5) * 60}px`);
          particlesRoot.appendChild(dot);
        }
      }

      function renderPanel(organ, index) {
        const color = colorFor(organ);
        panel.style.setProperty('--panel-glow', color.panelGlow);
        panelTitle.textContent = organ.name;
        panelTagline.textContent = organ.tagline;
        panelIndex.textContent = `${String(index + 1).padStart(2, '0')} / ${String(organs.length).padStart(2, '0')}`;

        if (panelFigure) panelFigure.classList.remove('is-loaded');
        panelImage.onload = () => {
          if (panelFigure) panelFigure.classList.add('is-loaded');
        };
        panelImage.alt = organ.imageAlt;
        panelImage.src = organ.image;
        if (panelImage.complete) {
          if (panelFigure) panelFigure.classList.add('is-loaded');
        }

        if (panelGlow) {
          panelGlow.style.background = `radial-gradient(circle at 50% 40%, transparent 58%, ${color.soft} 100%)`;
          panelGlow.style.boxShadow = `inset 0 0 0 1px ${color.soft}`;
        }

        const blocks = [];
        blocks.push(`<p class="organ-panel__paragraph">${escapeHtml(organ.sidePanelCopy)}</p>`);

        if (organ.supportIntro && organ.supportBullets && organ.supportBullets.length) {
          blocks.push(`
            <div style="--block-color: ${color.stroke}">
              <div class="organ-panel__block-title">
                <span aria-hidden="true">${circleDotSvg(color.stroke)}</span>
                <div class="hpe-hud-label">${escapeHtml(organ.supportIntro)}</div>
              </div>
              <ul class="organ-panel__list">
                ${organ.supportBullets
                  .map(
                    (item) => `
                      <li class="organ-panel__list-item">
                        <span class="organ-panel__bullet" aria-hidden="true"></span>
                        <span>${escapeHtml(item)}</span>
                      </li>
                    `
                  )
                  .join('')}
              </ul>
            </div>
          `);
        }

        if (organ.riskIntro && organ.riskBullets && organ.riskBullets.length) {
          blocks.push(`
            <div style="--block-color: ${color.stroke}">
              <div class="organ-panel__block-title">
                <span aria-hidden="true">${circleDotSvg(color.stroke)}</span>
                <div class="hpe-hud-label">${escapeHtml(organ.riskIntro)}</div>
              </div>
              <ul class="organ-panel__list">
                ${organ.riskBullets
                  .map(
                    (item) => `
                      <li class="organ-panel__list-item">
                        <span class="organ-panel__bullet" aria-hidden="true"></span>
                        <span>${escapeHtml(item)}</span>
                      </li>
                    `
                  )
                  .join('')}
              </ul>
            </div>
          `);
        }

        (organ.closingCopy || []).forEach((paragraph) => {
          blocks.push(`<p class="organ-panel__paragraph">${escapeHtml(paragraph)}</p>`);
        });

        panelBody.innerHTML = blocks.join('');

        if (organ.microCta) {
          panelCtaWrap.hidden = false;
          panelCta.href = shopUrl;
          panelCta.textContent = `${organ.microCta} →`;
        } else {
          panelCtaWrap.hidden = true;
        }

        renderParticles(color);
      }

      function escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function circleDotSvg(color) {
        return `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="1" fill="${color}"/></svg>`;
      }

      function openOrgan(id) {
        const index = organs.findIndex((organ) => organ.id === id);
        if (index < 0) return;
        activeId = id;
        hoveredId = null;
        root.classList.add('is-organ-open');
        document.documentElement.classList.add('is-organ-panel-open');
        panel.hidden = false;
        requestAnimationFrame(() => panel.classList.add('is-open'));
        renderPanel(organs[index], index);
        updateConnector(organs[index]);
        syncHotspotStates();
      }

      function closeOrgan() {
        activeId = null;
        root.classList.remove('is-organ-open');
        document.documentElement.classList.remove('is-organ-panel-open');
        panel.classList.remove('is-open');
        window.setTimeout(() => {
          if (!activeId) panel.hidden = true;
        }, 420);
        updateConnector(null);
        syncHotspotStates();
      }

      function go(delta) {
        if (!activeId) return;
        const index = organs.findIndex((organ) => organ.id === activeId);
        if (index < 0) return;
        const next = organs[(index + delta + organs.length) % organs.length];
        openOrgan(next.id);
      }

      root.querySelector('[data-organ-close]')?.addEventListener('click', closeOrgan);
      root.querySelector('[data-organ-prev]')?.addEventListener('click', () => go(-1));
      root.querySelector('[data-organ-next]')?.addEventListener('click', () => go(1));

      window.addEventListener(
        'scroll',
        (event) => {
          if (!activeId) return;
          if (event.target !== document && event.target !== document.documentElement) return;
          closeOrgan();
        },
        { passive: true, capture: true }
      );

      window.addEventListener('keydown', (event) => {
        if (!activeId) return;
        if (event.key === 'Escape') closeOrgan();
        if (event.key === 'ArrowLeft') go(-1);
        if (event.key === 'ArrowRight') go(1);
      });

      renderHotspots();
    }

    document.querySelectorAll('[data-hero]').forEach(initHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('[data-product-hero]');
    var slot = document.querySelector('[data-product-float-slot]');
    var product = document.querySelector('[data-product-float]');
    var visual = product && product.querySelector('.product-hero__product-visual');
    var scrollLink = document.querySelector('[data-product-hero-scroll]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var floating = false;
    var returning = false;
    var baseWidth = 0;
    var baseHeight = 0;
    var current = { x: 0, y: 0, scale: 1, rotate: 0, p: 0 };
    var target = { x: 0, y: 0, scale: 1, rotate: 0, p: 0 };
    var running = false;

    if (scrollLink) {
      scrollLink.addEventListener('click', function (event) {
        var targetEl = document.getElementById('human-body');
        if (!targetEl) return;
        event.preventDefault();
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        try {
          targetEl.setAttribute('tabindex', '-1');
          targetEl.focus({ preventScroll: true });
        } catch (e) {}
      });
    }

    if (!hero || !slot || !product || !visual) return;

    function markReady() {
      product.classList.add('is-settled');
      hero.classList.add('is-ready');
    }

    product.addEventListener(
      'animationend',
      function (event) {
        if (event.target !== product) return;
        markReady();
      },
      { once: true }
    );
    window.setTimeout(markReady, 1300);

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function ease(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function lerp(a, b, t) {
      return a + (b - a) * t;
    }

    function measureBase() {
      var rect = slot.getBoundingClientRect();
      if (rect.width > 4 && rect.height > 4) {
        baseWidth = rect.width;
        baseHeight = rect.height;
      }
    }

    function scrollProgress() {
      var heroTop = hero.getBoundingClientRect().top;
      var range = Math.max(window.innerHeight * 0.72, 400);
      return clamp(-heroTop / range, 0, 1);
    }

    function dockTarget() {
      var width = Math.min(84, Math.max(64, window.innerWidth * 0.1));
      var scale = width / Math.max(baseWidth, 1);
      var height = baseHeight * scale;
      return {
        scale: scale,
        left: window.innerWidth - 16 - width,
        top: window.innerHeight - 16 - height
      };
    }

    function setExit(amount) {
      hero.style.setProperty('--hero-exit', amount.toFixed(3));
    }

    function slotHome() {
      var rect = slot.getBoundingClientRect();
      return {
        x: rect.left,
        y: rect.top,
        scale: 1,
        rotate: 0,
        p: 0
      };
    }

    function distTo(point) {
      var dx = current.x - point.x;
      var dy = current.y - point.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function resetToHero() {
      var home = slotHome();
      product.style.transition = 'none';
      product.style.width = baseWidth + 'px';
      product.style.height = baseHeight + 'px';
      product.style.transform =
        'translate3d(' + home.x.toFixed(2) + 'px, ' + home.y.toFixed(2) + 'px, 0) scale(1)';
      visual.style.transform = '';
      product.style.setProperty('--shadow-opacity', '0.72');
      product.style.setProperty('--shadow-scale-x', '1');
      product.style.setProperty('--shadow-scale-y', '1');
      product.style.setProperty('--shadow-y', '0px');
      product.style.setProperty('--glow-opacity', '0.28');
      void product.offsetWidth;

      floating = false;
      returning = false;
      setExit(0);
      product.classList.remove('is-floating', 'is-docked', 'is-rested');
      product.classList.add('is-settled');
      product.setAttribute('tabindex', '-1');
      product.style.width = '';
      product.style.height = '';
      product.style.transform = '';
      product.style.transition = '';
      visual.style.transform = '';
    }

    function beginFloat() {
      if (!baseWidth) measureBase();
      var rect = product.getBoundingClientRect();
      returning = false;
      product.classList.add('is-settled', 'is-floating');
      product.classList.remove('is-docked', 'is-rested');
      product.style.transition = 'none';
      product.style.width = baseWidth + 'px';
      product.style.height = baseHeight + 'px';
      current.x = rect.left;
      current.y = rect.top;
      current.scale = 1;
      current.rotate = 0;
      current.p = scrollProgress();
      target.x = current.x;
      target.y = current.y;
      target.scale = 1;
      target.rotate = 0;
      target.p = current.p;
      product.style.setProperty('--glow-opacity', '0.18');
      floating = true;
      void product.offsetWidth;
    }

    function updateTargets() {
      if (!baseWidth) measureBase();
      var slotRect = slot.getBoundingClientRect();
      if (!baseWidth || slotRect.width < 4) return false;

      var raw = scrollProgress();

      if (reduceMotion) {
        setExit(raw > 0.85 ? 1 : 0);
        if (raw < 0.88) {
          if (floating) resetToHero();
          return false;
        }
        raw = 1;
      }

      if (!floating && raw > 0.045) {
        beginFloat();
      }

      if (!floating) {
        setExit(0);
        return false;
      }

      setExit(clamp(raw * 1.35, 0, 1));

      if (raw < 0.08) {
        returning = true;
        var home = slotHome();
        target.x = home.x;
        target.y = home.y;
        target.scale = 1;
        target.rotate = 0;
        target.p = raw;
        return true;
      }

      returning = false;
      var p = ease(raw);
      var dock = dockTarget();
      var arc = Math.sin(p * Math.PI) * (-Math.min(56, window.innerHeight * 0.06));
      var rotate = 0;

      target.p = raw;
      target.scale = lerp(1, dock.scale, p);
      target.x = lerp(slotRect.left, dock.left, p);
      target.y = lerp(slotRect.top, dock.top, p) + arc;
      target.rotate = 0;
      return true;
    }

    function applyShadow(lift, docked, rested, returningHome) {
      var opacity;
      var scaleX;
      var scaleY;
      var y;
      var glow;

      if (returningHome) {
        var homeT = 1 - Math.min(current.p * 8, 1);
        opacity = lerp(0.28, 0.72, homeT);
        scaleX = lerp(0.62, 1, homeT);
        scaleY = 1;
        y = 0;
        glow = lerp(0.04, 0.28, homeT);
      } else if (docked) {
        opacity = rested ? 0.58 : 0.48;
        scaleX = 0.88;
        scaleY = 1;
        y = 2;
        glow = rested ? 0.16 : 0.1;
      } else {
        opacity = lerp(0.72, 0.2, lift);
        scaleX = lerp(1, 0.52, lift);
        scaleY = lerp(1, 0.72, lift);
        y = lift * 10;
        glow = lerp(0.28, 0.02, Math.min(lift * 1.4, 1));
      }

      product.style.setProperty('--shadow-opacity', opacity.toFixed(3));
      product.style.setProperty('--shadow-scale-x', scaleX.toFixed(3));
      product.style.setProperty('--shadow-scale-y', scaleY.toFixed(3));
      product.style.setProperty('--shadow-y', y.toFixed(2) + 'px');
      product.style.setProperty('--glow-opacity', glow.toFixed(3));
    }

    function applyFrame() {
      var dock = dockTarget();
      var dx = current.x - dock.left;
      var dy = current.y - dock.top;
      var dockDist = Math.sqrt(dx * dx + dy * dy);
      var docked =
        !returning &&
        current.p > 0.93 &&
        dockDist < 8 &&
        Math.abs(current.scale - dock.scale) < 0.02;
      var rested = docked && dockDist < 1.5;
      var lift = Math.sin(clamp(current.p, 0, 1) * Math.PI);

      product.classList.toggle('is-docked', docked);
      product.classList.toggle('is-rested', rested);
      product.setAttribute('tabindex', docked ? '0' : '-1');
      product.style.transform =
        'translate3d(' +
        current.x.toFixed(2) +
        'px, ' +
        current.y.toFixed(2) +
        'px, 0) scale(' +
        current.scale.toFixed(4) +
        ')';
      visual.style.transform = '';
      applyShadow(lift, docked, rested, returning);
    }

    function maybeFinishReturn() {
      if (!returning) return false;
      var home = slotHome();
      var close =
        distTo(home) < 1.25 &&
        Math.abs(current.scale - 1) < 0.012 &&
        Math.abs(current.rotate) < 0.2;
      if (!close) return false;
      resetToHero();
      return true;
    }

    function tick() {
      running = true;
      var active = updateTargets();

      if (!active) {
        running = false;
        return;
      }

      var damp = reduceMotion ? 1 : returning ? 0.22 : current.p > 0.85 ? 0.18 : 0.14;
      current.x = lerp(current.x, target.x, damp);
      current.y = lerp(current.y, target.y, damp);
      current.scale = lerp(current.scale, target.scale, damp);
      current.rotate = lerp(current.rotate, target.rotate, damp);
      current.p = lerp(current.p, target.p, damp);

      if (maybeFinishReturn()) {
        running = false;
        return;
      }

      applyFrame();
      window.requestAnimationFrame(tick);
    }

    function ensureLoop() {
      if (!running) tick();
    }

    measureBase();
    window.addEventListener('scroll', ensureLoop, { passive: true });
    window.addEventListener(
      'resize',
      function () {
        if (!floating) measureBase();
        ensureLoop();
      },
      { passive: true }
    );
    ensureLoop();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const card = document.querySelector('[data-shop-card]');
    if (!card) return;

    const trust = document.querySelector('[data-p0-pdp-trust]');
    const submit = card.querySelector('.shop-card__submit');
    if (trust && submit) {
      submit.before(trust);
      trust.hidden = false;
    }

    const tagline = card.querySelector('.shop-card__tagline');
    if (tagline && /verified\s+5\s*ppm/i.test(tagline.textContent || '')) {
      if (card.classList.contains('shop-card--gold')) {
        tagline.textContent = 'Premium glass bottles — produced to a 5 ppm deuterium target';
      } else {
        tagline.textContent = 'Portable PET bottles — produced to a 5 ppm deuterium target';
      }
    }

    card.querySelectorAll('.shop-card__spec').forEach((row) => {
      const label = row.querySelector('span:first-child');
      const value = row.querySelector('.shop-card__spec-value');
      if (!label || !value) return;
      const key = (label.textContent || '').trim().toLowerCase();
      if (key === 'deuterium') {
        value.textContent = '5 ppm target';
      }
      if (key === 'verification') {
        label.textContent = 'Lab evidence';
        const labLink = document.querySelector('[data-p0-lab-link]');
        if (labLink) {
          const anchor = document.createElement('a');
          anchor.href = labLink.href;
          anchor.textContent = 'Published lab results';
          anchor.style.color = 'inherit';
          anchor.style.textUnderlineOffset = '0.15em';
          value.replaceChildren(anchor);
        }
      }
    });

    const subOption = card.querySelector('[data-purchase-option="subscription"]');
    const row = subOption && subOption.querySelector('.shop-card__option-row');
    const savings = row && row.querySelector('[data-savings-label]');
    if (row && !row.querySelector('[data-p0-sub-price]')) {
      const wrap = document.createElement('span');
      wrap.className = 'p0-subscription-value';
      wrap.setAttribute('data-p0-sub-price', '');

      const price = document.createElement('span');
      price.className = 'shop-card__option-price';
      price.textContent = card.dataset.defaultPlanPrice || '';
      wrap.appendChild(price);

      if (savings) wrap.appendChild(savings);
      row.appendChild(wrap);
    }

    const terms = document.querySelector('[data-p0-subscription-terms]');
    if (terms && subOption) {
      subOption.after(terms);
      terms.hidden = false;
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
